import React from "react";

const HomeSection = () => (
    <section
        id="home"
        style={{
            textAlign: `center`,
            background: `linear-gradient(125deg, #47236A 0%, #3D1E81 100%)`,
            height: `calc(100vh + 53px)`,
            alignItems: `center`,
            display: `flex`,
            flexDirection: `column`,
            justifyContent: `center`,
            color: `#ffffff88`
        }}
    >
        <div className="star-container">
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
        </div>
        <h1>Hey I'm Marcus</h1>
        <h1>Coming up with a good opener is tough...</h1>
        <h4>Hire me perhaps?</h4>
        <div style={{ marginTop: `2rem`, zIndex: 8 }}>
            <a href="https://docs.google.com/document/d/128r7KhH7D0bYKmQNuzY9DFC0KMQfTLhZgJVTplE6jnA/export?format=pdf">
                Cover Letter
            </a>
            <a href="https://docs.google.com/document/d/1AmKS-EKP1tfPgs2YqhxzN5sr98eMyVu6ghXAx6Q8FoI/export?format=pdf">
                Resume
            </a>
        </div>
    </section>
)

export default HomeSection
